import React, { useEffect, useState } from "react";
import FingerLimitsTable from "./components/FingerLimitsTable";
import Edit from "./modals/Edit";
import View from "./modals/View";
import Filter from "./modals/Filter";
import Create from "./modals/Create";

import Switch from "@material-ui/core/Switch/index";
import FormControlLabel from "@material-ui/core/FormControlLabel/index";
import axios from "axios";
import { useSelector } from "react-redux";
import { updateObject } from "../../../helpers/updateObject";

function FingerLimit(props) {
  const token = useSelector((state) => state.auth.token);
  const [fingerLimits, setFingerLimits] = useState([]);
  const [chooseFingerLimitId, setChooseFingerLimitId] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [deleteFingerLimitsIds, setDeleteFingerLimitsIds] = useState([]);
  const [showView, setShowView] = useState(false);
  const [showCreate, setShowCreate] = useState(false);

  const [showEdit, setShowEdit] = useState(false);
  const [showFilter, setShowFilter] = React.useState(false);
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [count, setCount] = useState(0);
  const [orderBy, setOrderBy] = useState("desc");
  const [sortField, setSortField] = useState("id");
  const [filterInputs, setFilterInputs] = useState({
    middleName: "",
    name: "",
    surname: "",


  
  });
  const toggleDrawer = (open) => (event) => {
    setShowView(open);
  };
  function handleChange() {
    setShowFilter((key) => !key);
  }

  const onFingerLimits = (orderBy, sortField, skip, take, filterInputs = {}) => {
    const {
      middleName,
      name,
      surname,
      
    } = filterInputs;
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}user/limit?dir=${orderBy}&field=${sortField}&pageNumber=${skip}&pageSize=${take}${middleName ? `&middleName=${middleName}` : ""}${name ? `&name=${name}` : ""}${surname ? `&surname=${surname}` : ""}`, {
        headers: { Authorization: `bearer ${token}` },
      })
      .then(({ data: { content ,totalElements} }) => {
        setIsLoading(false);
        setFingerLimits(content);
        setIsError(false);
        setCount(totalElements)
      })
      .catch(() => {
        setIsLoading(false);
        setFingerLimits([]);
        setIsError(true);
      });
  };

  const onFingerLimitChoose = (id) => {
    return axios.get(`${process.env.REACT_APP_API_URL}user/limit/${id}`, {
      headers: { Authorization: `bearer ${token}` },
    });
  };

  const filterInputsUpdate = (name, value) => {
    const updateFiltersInput = updateObject(filterInputs, {
      [name]: value,
    });

    setFilterInputs(updateFiltersInput);
    setSkip(0);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      onFingerLimits(orderBy, sortField, skip, take, filterInputs);
    }, 500);
    return () => clearTimeout(timer);
  }, [orderBy, sortField, skip, take, filterInputs]);


  return (
    <div className="row bg-white rounded">
      <div className="col-12 d-flex align-items-center py-4">
        <h6 className="display-4 mb-0">İstifadəçi kartları və barmaq izi limiti</h6>
        <FormControlLabel
          control={
            <Switch
              checked={showFilter}
              onChange={handleChange}
              color="secondary"
            />
          }
          label={showFilter ? "Filtri gizlət" : "Filtri göstər"}
          className="ml-auto mb-0"
        />
      </div>
      <FingerLimitsTable
        fingerLimits={fingerLimits}
        isLoading={isLoading}
        isError={isError}
        setChooseFingerLimitId={setChooseFingerLimitId}
        setOpenView={toggleDrawer(true)}
        setShowEdit={setShowEdit}
        setDeleteFingerLimitsIds={setDeleteFingerLimitsIds}
        deleteFingerLimitsIds={deleteFingerLimitsIds}
        setSortField={setSortField}
        setOrderByTable={setOrderBy}
        sortField={sortField}
        orderBy={orderBy}
        count={count}
        updateSkip={setSkip}
        updateTake={setTake}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
        setShowCreate={setShowCreate}
      />
    {showCreate && (
        <Create
          show={showCreate}
          onHide={setShowCreate}
          onFingerLimits={onFingerLimits}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
          filterInputs={filterInputs}
        />
      )}
      {showView && (
        <View
          open={showView}
          onClose={toggleDrawer(false)}
          onFingerLimitChoose={onFingerLimitChoose}
          chooseFingerLimitId={chooseFingerLimitId}
        />
      )}

      {showEdit && (
        <Edit
          show={showEdit}
          onHide={setShowEdit}
          onFingerLimits={onFingerLimits}
          id={chooseFingerLimitId}
          onFingerLimitChoose={onFingerLimitChoose}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
          filterInputs={filterInputs}

        />
      )}


      <Filter
        show={showFilter}
        onHide={handleChange}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
        setFilterInputs={setFilterInputs}

      />
    </div>
  );
}

export default FingerLimit;
